import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CustomTabs from "../../components/ui/CustomTabs";
import ExpCalculator from "../../components/calcComponents/ExpCalculator";
import CraftingCalculator from "../../components/calcComponents/CraftingCalculator";
import ResourceCalculator from "../../components/calcComponents/ProduceCalculator";
import EnergyCalculator from "../../components/calcComponents/EnergyCalculator";
import CPPCalculator from "../../components/calcComponents/cppCalculator";
import StakingPowerCalc from "../../components/calcComponents/StakingPowerCalc";
import { fetchItems } from "../../utils/fetchItemData";
import MiscCalculator from "../../components/calcComponents/MiscCalculator";

export default function Calculator() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [activeTab, setActiveTab] = useState("exp");

  useEffect(() => {
    // Set initial tab from URL
    if (tab) {
      setActiveTab(tab);
    }

    // Load items data
    const loadItems = async () => {
      try {
        const itemId = null;
        await fetchItems({itemId, setItems});
      } catch (err) {
        console.error("Error fetching item data:", err);
      }
    };
    loadItems();
  }, [tab]);

  const calculatorTabs = [
    { key: "exp", label: "EXP to Level", component: <ExpCalculator items={items}/> },
    { key: "craft", label: "Crafting Calculator", component: <CraftingCalculator items={items} /> },
    { key: "producer", label: "Resource Calculator", component: <ResourceCalculator items={items} /> },
    { key: "energy", label: "Energy Calc", component: <EnergyCalculator items={items} /> },
    { key: "currency", label: "CPP Calculator", component: <CPPCalculator /> },
    { key: "staking", label: "Staking Power", component: <StakingPowerCalc /> },
    { key: "coinprice", label: "Coin Price Calculator", component: <MiscCalculator /> },
  ];

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/tools/calculator/${tabKey}`);
  };

  return (
    <div className="panel-style">
      <h1 className="panel-heading">Pixels Calculators</h1>
      <CustomTabs 
        tabs={calculatorTabs} 
        activeTab={activeTab} 
        onTabChange={handleTabChange}
      />
    </div>
  );
}